<script lang="ts">
  import Info from '~/icons/Info.svelte';
  import type { Snippet } from 'svelte';

  const { status, hideIcon = false, width = undefined, children }: { status: 'success' | 'warn' | 'error'; hideIcon?: boolean; width?: string | number; children: Snippet } = $props();
</script>

<div class="status {status}" style:width>
  {#if !hideIcon}
    <span class="icon">
      <Info size={24} />
    </span>
  {/if}
  <div class="body">
    {@render children()}
  </div>
</div>

<style lang="scss">
  @use 'sass:color';
  @use '~/theme/theme.scss';
  .status {
    display: flex;
    border-radius: 0.75rem;
    padding: 0.5rem;
    gap: 0.5rem;
    & .icon {
      float: left;
      padding-top: 0.5em;
      margin-right: 0.5em;
    }
    &.warn {
      background-color: color.adjust(theme.$status-warn, $lightness: 30%);
      border: 2px solid color.adjust(theme.$status-warn, $lightness: 0%);
    }
    &.success {
      background-color: color.adjust(theme.$star-bonus, $lightness: 30%);
      border: 2px solid color.adjust(theme.$star-bonus, $lightness: 0%);
    }
    :global(html.dark-mode) &.warn {
      background-color: color.adjust(theme.$status-warn, $lightness: -40%);
      border: 2px solid color.adjust(theme.$status-warn, $lightness: -10%);
    }
    :global(html.dark-mode) &.success {
      background-color: color.adjust(theme.$star-bonus, $lightness: -20%);
      border: 2px solid color.adjust(theme.$star-bonus, $lightness: 0%);
    }
    & .body {
      display: flex;
      flex-direction: row;
      gap: 0.5rem;
      align-items: center;
      flex-wrap: wrap;
      justify-content: space-between;
      text-align: left;
    }
  }
</style>
